var _g, _path, _g2, _g3, _path2, _polygon, _g4, _polygon2, _polygon3, _polygon4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVssx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    enableBackground: "new 0 0 96 96",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TEMPLATE",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D0D0D0",
    d: "M96,0v96H0V0H96 M97-1h-1H0h-1v1v96v1h1h96h1v-1V0V-1L97-1z"
  })), /*#__PURE__*/React.createElement("g", {
    display: "inline",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF3A6D",
    d: "M90,6v84H6V6H90 M96,0H0v96h96V0L96,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "ICONS"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 22.0974,
    y1: 7.5965,
    x2: 89.9026,
    y2: 88.4035
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2264,
    style: {
      stopColor: "#FCFCFC",
      stopOpacity: 0.0226
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3626,
    style: {
      stopColor: "#F4F4F4",
      stopOpacity: 0.0363
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    style: {
      stopColor: "#E6E6E6",
      stopOpacity: 0.0475
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5744,
    style: {
      stopColor: "#D1D1D1",
      stopOpacity: 0.0574
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6652,
    style: {
      stopColor: "#B7B7B7",
      stopOpacity: 0.0665
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7498,
    style: {
      stopColor: "#979797",
      stopOpacity: 0.075
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8297,
    style: {
      stopColor: "#707070",
      stopOpacity: 0.083
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9057,
    style: {
      stopColor: "#444444",
      stopOpacity: 0.0906
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9761,
    style: {
      stopColor: "#121212",
      stopOpacity: 0.0976
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M88,6H24v84h64V6z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 8,
    fill: "#FFFFFF",
    width: 60,
    height: 80
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C8C8C8",
    d: "M32,14v32h2.4444H54v-2.3333V16.3333V14H34.4444H32z M52,16v28H34V16H52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8C8C8",
    d: "M32,50v32h2.4444H54v-2.3333V52.3333V50H34.4444H32z M52,52v28H34V52H52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8C8C8",
    d: "M60.4444,14H58v32h2.4444H80v-2.3333V16.3333V14H60.4444z M78,44H60V16h18V44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8C8C8",
    d: "M58,50v32h2.4444H80v-2.3333V52.3333V50H60.4444H58z M78,52v28H60V52H78z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#949494",
    d: "M24,6v84h64V6H24z M86,88H26V8h60V88z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#3955A3",
    points: "8,34 48,28 48,80 8,74  "
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M38,42l-7.3294,24h-5.4303L18,42h5.1632l4.4362,16.7029c0.2374,0.9038,0.3807,1.7019,0.4303,2.3933h0.089 c0.0691-0.7474,0.2226-1.5675,0.4599-2.4603L32.9852,42H38z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 67.34,
    y1: 19.66,
    x2: 84.46,
    y2: 2.54
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8537,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2134
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.25
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_2_)",
    points: "24,6 24,8 86,8 86,56 88,56 88,6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 35.4329,
    y1: 87.5399,
    x2: 36.4565,
    y2: 77.9017
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#828282",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1699,
    style: {
      stopColor: "#7E7E7E",
      stopOpacity: 0.0341
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346,
    style: {
      stopColor: "#717171",
      stopOpacity: 0.0694
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5248,
    style: {
      stopColor: "#5D5D5D",
      stopOpacity: 0.1053
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7057,
    style: {
      stopColor: "#404040",
      stopOpacity: 0.1415
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8863,
    style: {
      stopColor: "#1B1B1B",
      stopOpacity: 0.1778
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9972,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.2
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_3_)",
    points: "48,88 24,88 24,76.4 48,80  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 28,
    y1: 78.375,
    x2: 28,
    y2: 29.5168
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8587,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1546
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.18
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_4_)",
    points: "48,28 8,34 8,74 48,80  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVssx);
export default __webpack_public_path__ + "static/media/vssx.87d842c5d135acb99711ae7e147c0a6d.svg";
export { ForwardRef as ReactComponent };